import { Variavel } from './../variaveis/variavel';
import { Certificado } from './../certificados/certificado';
import { Unidade } from './../unidades/unidade';
import { Upload } from './../uploads/upload';

export class Documento{
  id: number;
  nome: string;
  descricao: string;
  variaveis: Array<any>;
  certificado: any;
  created_at: string;
  updated_at:string;
  unidade_id: number;
  centro_id: number;
  grupo_id:number;
  unidade: Unidade;
  local: string;
  uploads: Upload

  constructor(){
    let variavel = new Variavel();

    variavel.identificador = 'nome';
    variavel.descricao = 'nome do participante';
    variavel.tipo_id = '2';
    variavel.padrao = false;

    this.variaveis = [ variavel ];

    this.certificado = new Certificado();

    //this.tipo_documento = new Certificado();
  }
}



// WEBPACK FOOTER //
// ./src/app/documentos/documento.ts